/**
 * TODO 当前文件属于产品卡片配置文件，通过配置的方式完成业务功能的开发，实现组件的高内聚、低耦合
 * 配置文件说明如下
 *  ProductCfg 对象最外层的包裹文件
 *    planType 规划类型
 *    subType 规划类型下子类型 如： 寿险、年金
 *    insuranceType 保险类型
 *    listPage 列表页模块的配置文件
 *      tableCfg 表格相关配置文件 详情请见 src/components/TsTable/TsTable.vue  表格demo请见 src/components/TsTable/demo.vue
 *      btmBtnList 表格底部按钮数组 接口详情请见 src/types/common/btn.d.ts
 *    editSettings 新增编辑模块配置文件
 *      countUrlFn 分析结果接口函数
 *      annuityProBtnValue 年金产品按钮默认勾选项(默认全部)
 *      formObj 输入框表单
 *      annuityProBtnList  年金产品按钮组数据
 *      inpOutFormList 页面输出项表单数组数据
 *      chartEnum 图表枚举
 *      tableHead 编辑页面内表头
 *
 *    outputSetting 输出页面配置
 *      formInfoList 信息表单列表
 */

import { ProductCfg } from '@/types/newPersion'
import { actionStatisticsList } from '@/api/newPersion'

const ProductCfg: ProductCfg = {
  planType: 'Pension',
  subType: 'annuity',
  insuranceType: 'Annuity',
  listPage: {
    tableCfg: {
      titleObjCfg: {
        hide: true,
        // title: '年金保险产品选择',
        // options: {
        //   dropdown: false,
        //   arr: [
        //     {
        //       type: 'add',
        //       name: '新增年金保险'
        //     }
        //   ]
        // }
      },
      tableHead: [
        {
          propName: 'insuredName',
          labelName: '被保险人'
        },
        {
          // type: 'first',
          propName: 'insuranceName',
          labelName: '被保险产品名称'
        },
        {
          type: 'edit',
          labelName: '编辑',
          propName: 'edit',
          options: {
            dropdown: false,
            arr: [

              {
                type: 'edit',
                name: '编辑',
                btnType: 'text'
              },
              {
                type: 'del',
                name: '删除',
                btnType: 'text'
              }
            ]
          }
        }
      ],
    },
    btmBtnList: [
      { name: '返回', btnType: 'no' },
      { name: '确定', btnType: 'ok' }
    ]
  },
  editSettings: {
    name: '年金保险',
    countUrlFn: async (params: {}, urlFn?: Function) => {
      if (urlFn) {
        return await urlFn(params)
      } else {
        return await actionStatisticsList(params)
      }
    },
    annuityProBtnValue: '',
    formObj: {
      customerMember: '',
      insuranceId: '',
      yearlyAmount: '',
      years: '',
    },
    formRuleList: ['customerMember', 'insuranceId', 'yearlyAmount', 'years'],
    annuityProBtnList: [
      {
        type: '',
        name: '全部',
      },
      {
        type: 'ChildrenEduAnnuity',
        name: '子女年金',
      },
      {
        type: 'PensionAnnuity',
        name: '养老年金',
      },
      {
        type: 'StandardTermAnnuity',
        name: '其他类型年金',
      },
    ],
    insuranceTypeObj: {
      ChildrenEduAnnuity: 'ChildrenEdu',
      PensionAnnuity: 'Pension',
      StandardTermAnnuity: 'Annuity'
    },
    inpOutFormList: [{
      disabled: true,
      label: '累计保证年金领取:',
      suffix: '元',
      type: 'number',
      value: 'totalAnnuityDraw',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末生存总利益:',
      suffix: '元',
      type: 'number',
      value: 'totalAmountDraw',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末生存总利益/总保费:',
      suffix: '倍',
      type: 'number',
      value: 'annuityMultiple',
      inputWidth: '400px'
    }],
    chartEnum: {
      age: '',
      yearMny: '年保费', // 年保费
      fixMny: '固定年金领取', // 固定年金领取
      bonus: '中等红利' // 中等红利
    },
    tableHead: [
      {
        propName: 'age',
        labelName: '年龄'
      }, {
        propName: 'yearMny',
        labelName: '年缴保费(元)'
      }, {
        propName: 'fixMny',
        labelName: '保证年金领取(元)'
      }, {
        propName: 'cashValue',
        labelName: '主险现金价值(元)'
      }, {
        propName: 'bonus',
        labelName: '中档红利(元)'
      }, {
        propName: 'universalAccountValue',
        labelName: '不领取情况下万能账户价值(元)',
        width: '180px'
      }, {
        propName: 'lifeBenefit',
        labelName: '生存总利益(元)',
        width: '160px'
      }
    ]
  },
  outputSetting: {
    formInfoList: [
      {
        title: '产品名:',
        value: 'insuranceName',
        unit: '',
      },
      {
        title: '被保险人:',
        value: 'insuredName',
        unit: '',
      },
      {
        title: '年缴保费:',
        value: 'yearlyAmount',
        unit: '元',
      },
      {
        title: '累计保证领取年金:',
        value: 'insuranceStatistics.totalAnnuityDraw',
        unit: '元',
      },
      {
        title: '期末生存总利益:',
        value: 'insuranceStatistics.totalAmountDraw',
        unit: '元',
      },
      {
        title: '期末生存总利益/总保费:',
        value: 'insuranceStatistics.annuityMultiple',
        unit: '倍',
      }
    ]
  }
}
export default ProductCfg
